export var DeviceClient;
(function (DeviceClient) {
    DeviceClient["Web"] = "web";
    DeviceClient["PWA"] = "pwa";
    DeviceClient["Android"] = "android";
    DeviceClient["iOS"] = "ios";
    DeviceClient["Mac"] = "mac";
    DeviceClient["Windows"] = "windows";
    DeviceClient["Other"] = "other";
})(DeviceClient || (DeviceClient = {}));
export var DeviceOS;
(function (DeviceOS) {
    DeviceOS["Android"] = "android";
    DeviceOS["iOS"] = "ios";
    DeviceOS["Windows"] = "windows";
    DeviceOS["Linux"] = "linux";
    DeviceOS["MacOS"] = "macos";
    DeviceOS["Other"] = "other";
})(DeviceOS || (DeviceOS = {}));
export var DeviceBrowser;
(function (DeviceBrowser) {
    DeviceBrowser["Chrome"] = "chrome";
    DeviceBrowser["Firefox"] = "firefox";
    DeviceBrowser["Safari"] = "safari";
    DeviceBrowser["Edge"] = "edge";
    DeviceBrowser["Opera"] = "opera";
    DeviceBrowser["Other"] = "other";
})(DeviceBrowser || (DeviceBrowser = {}));
